import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { LocationData } from "../../../models/LocationData";
import DataSvc from "../../../services/dataSvc";
import { TextFileDownload } from "../../Common/TextFileDownload";
import Checkbox from "../../FormElement/Checkbox";
import { TimespanPicker } from "../TimespanPicker";
import { useTimespanPicker } from "../TimespanPicker/hooks";

type IDownloadLocationStatsProps = {
  organizationId: string;
  locations: LocationData[];
};

export const DownloadLocationStats: React.FC<IDownloadLocationStatsProps> = (
  props
) => {
  const { locations, organizationId } = props;
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`dataDownloadPage.downloadLocationStats.${key}`);

  const [options, setOptions] = useState<{
    reply_percentage: boolean;
  }>({
    reply_percentage: true,
  });

  const timespan = useTimespanPicker();

  const queryKey = useMemo(
    () => [
      "download-location-stats",
      timespan.timespan,
      locations.map((location) => location.id.toString()),
      options,
    ],
    [timespan, locations, options]
  );
  const queryFunction = useCallback(async () => {
    const data = await DataSvc.getFacilityDataLocationStats({
      organizationId,
      timespan: timespan.timespan,
      locations,
      params: {
        reply_percentage: options.reply_percentage,
      },
    });
    return { filename: "location-stats", content: data };
  }, [timespan, locations, organizationId, options]);

  return (
    <div className="white-border-panel download-metrics">
      <h3>{t("download_location_stats")}</h3>
      <div className="content">
        <div className="download-metrics-controls">
          <TimespanPicker timespan={timespan} />
        </div>
        <div>
          <Checkbox
            id="reply_percentage"
            label={t("reply_percentage")}
            checked={options.reply_percentage}
            onChange={() =>
              setOptions({
                ...options,
                reply_percentage: !options.reply_percentage,
              })
            }
          />
        </div>
        <TextFileDownload queryKey={queryKey} queryFunction={queryFunction} />
      </div>
    </div>
  );
};
